import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";

export class LanguageNav extends Component {
	subNavToggle: JQuery;
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);
		this.subNavToggle = $(".lang-accord-toggle");

		if (!this.subNavToggle) {
			console.warn("No subnav toggle found to apply toggle effect.");
		}

		this.applyToggleEffect();
		this.applyCloseEffect();
		this.applyLangClickEvt();
	}

	applyToggleEffect(): void {
		this.subNavToggle.on("click keypress", function (
			e: JQuery.TriggeredEvent
		): void {
			e.preventDefault();

			const $target = $(e.target);

			const $accordContent = $target.next(".accord-toggle-content");

			if (e.key === "Enter" || e.type === "click") {
				if ($target.hasClass("expanded")) {
					$accordContent.stop().slideUp("fast", () => {
						$target.removeClass("expanded");
						$target.attr("aria-expanded", "false");
					});
				} else {
					$accordContent.stop().slideDown("fast", () => {
						$target.addClass("expanded");
						$target.attr("aria-expanded", "true");
					});
				}
			}
		});
	}

	applyCloseEffect(): void {
		$(document).on("click", () => {
			if (this.subNavToggle.hasClass("expanded")) {
				$(".accord-toggle-content").slideUp();
				this.subNavToggle.removeClass("expanded");
				this.subNavToggle.attr("aria-expanded", "false");
			}
		});
	}

	applyLangClickEvt(): void {
		const languages = this._element.querySelectorAll(
			".accord-toggle-content li"
		);

		if (!languages) {
			console.warn(
				"No languages dropdown found in dropdown for elem: .accord-toggle-content"
			);

			return;
		}

		languages.forEach(l =>
			l.addEventListener("click", () => {
				if (!l.classList.contains("selected")) {
					languages.forEach(_l => _l.classList.remove("selected"));
					l.classList.add("selected");
				}
			})
		);
	}
}

ComponentFactory.registerComponent("languageNav", LanguageNav);
